export class OrderItemDto {

    public readonly lineItemId: string;
    public readonly quantity: number;
    public readonly sku: string;
    public readonly name: string;
    public readonly position: string;
    public readonly shopifyName: string;

    constructor(lineItemId: string, quantity: number, sku: string, name: string,
                position: string, shopifyName: string) {
        this.lineItemId = lineItemId;
        this.quantity = quantity;
        this.sku = sku;
        this.name = name;
        this.position = position;
        this.shopifyName = shopifyName;
    }
}
